import React from 'react';
import { getTextThemeProvider } from 'venn-ui-kit';

const CookiePolicyLink = () => {
  const { COOKIE_POLICY } = getTextThemeProvider().legalDocuments;
  const title = COOKIE_POLICY.titles[0]?.text ?? 'Cookie Policy';
  return (
    <a href={COOKIE_POLICY.baseUrl} target="_blank" rel="noopener noreferrer">
      {title}
    </a>
  );
};

export default CookiePolicyLink;
